export var WebSocketConfig = {
    AI_ASSISTANT_URL: process.env.NODE_ENV === 'production'
        ? 'wss://ws.acewill.cn/ws'
        : 'ws://localhost:81/ws',
    RECONNECT_MAX_ATTEMPTS: 5,
    RECONNECT_INTERVAL: 3000,
    HEARTBEAT_INTERVAL: 30000,
    MESSAGE_TYPES: {
        USER_MESSAGE: 'user_message',
        USER_FILE: 'user_file',
        USER_MENU_CLICK: 'user_menu_click',
        USER_SELECT_CLICK: 'user_menu_click',
        AI_RESPONSE: 'ai_response',
        SYSTEM_NOTIFICATION: 'system_notification',
        HEARTBEAT: 'heartbeat'
    }
};
export default WebSocketConfig;
